import { useFormContext } from "react-hook-form";
import { FormattedMessage } from "react-intl";
import moment from "moment";

import DatePicker from "components/atoms/DatePicker/DatePicker";
import TimeInput from "components/atoms/TimeInput/TimeInput";
import Alert from "components/molecules/Alert/Alert";
import { DateTimeFormat, formatDate } from "helpers/dateTimeHelper";

type EditScheduleProps = {
  shipmentDetails: any;
};

export default function EditScheduleForm(props: EditScheduleProps) {
  const { shipmentDetails } = props;
  const { watch } = useFormContext();
  const [pickup_date, estimated_delivery_date] = [watch("pickup_date"), watch("estimated_delivery_date")];
  const showError =
    pickup_date && estimated_delivery_date && moment(pickup_date).isSameOrAfter(moment(estimated_delivery_date));

  const isPoPSubmitted = shipmentDetails?.schedule?.is_proof_of_pickup_submitted;
  const popDate = shipmentDetails?.schedule?.proof_of_pickup_date;
  const popTime = shipmentDetails?.schedule?.proof_of_pickup_time;

  return (
    <>
      <div className="d-flex">
        {isPoPSubmitted ? (
          <div className="d-flex flex-column">
            <div className="font-b3 mb-1">
              <FormattedMessage id="general.estimatedPickupTime" defaultMessage="Estimated pickup time" />
            </div>
            <div className="font-b4">{formatDate(`${popDate} ${popTime}`, DateTimeFormat.fullDateTimeFormat)}</div>
          </div>
        ) : (
          <>
            <div>
              <label className="required">
                <FormattedMessage id="tracking.components.editScheduleDialog.pickupDate" defaultMessage="Pickup Date" />
              </label>
              <DatePicker wrapperClassNames="w-192" required name="pickup_date" />
            </div>
            <div className="ml-3">
              <label className="required">
                <FormattedMessage id="tracking.components.editScheduleDialog.pickupTime" defaultMessage="Pickup Time" />
              </label>
              <TimeInput name="pickup_time" required outputFormat="HH:mm" />
            </div>
          </>
        )}
      </div>

      <div className="d-flex mt-3">
        <div>
          <label className="required">
            <FormattedMessage
              id="tracking.components.editScheduleDialog.estimatedDeliveryDate"
              defaultMessage="Estimated Delivery Date"
            />
          </label>
          <DatePicker wrapperClassNames="w-192" required name="estimated_delivery_date" />
          {showError && (
            <Alert variant="danger" className="w-192 mt-2">
              Delivery date-time should be greater than pickup date-time (note: timezone is considered as well)
            </Alert>
          )}
        </div>
        <div className="ml-3">
          <label className="required">
            <FormattedMessage
              id="tracking.components.editScheduleDialog.estimatedDeliveryTime"
              defaultMessage="Estimated Delivery Time"
            />
          </label>
          <TimeInput name="estimated_delivery_time" required outputFormat="HH:mm" />
        </div>
      </div>
    </>
  );
}
